/**
 * Verified URLs Table - Q1 2026 Update
 *
 * These URLs have been verified to work on axis.com.
 * Updated: 2026-02-04 with Q1 2026 Axis Product Catalog
 *
 * Format: MODEL (normalized, no "AXIS" prefix) → Full URL
 */

export const VERIFIED_URLS: Record<string, string> = {
  // ===========================================================================
  // P-SERIES DOMES (P32xx) - ARTPEC-8/9 AI-Powered
  // ===========================================================================

  // P32xx - Versatile AI-powered domes (ARTPEC-9)
  'P3265-LV': 'https://www.axis.com/products/axis-p3265-lv',
  'P3265-LVE': 'https://www.axis.com/products/axis-p3265-lve',
  'P3265-V': 'https://www.axis.com/products/axis-p3265-v',
  'P3267-LV': 'https://www.axis.com/products/axis-p3267-lv',
  'P3267-LVE': 'https://www.axis.com/products/axis-p3267-lve',
  'P3268-LV': 'https://www.axis.com/products/axis-p3268-lv',
  'P3268-LVE': 'https://www.axis.com/products/axis-p3268-lve',
  'P3268-SLVE': 'https://www.axis.com/products/axis-p3268-slve',

  // P32xx - NEW ARTPEC-9 models (2025-2026)
  'P3275-LV': 'https://www.axis.com/products/axis-p3275-lv',
  'P3275-LVE': 'https://www.axis.com/products/axis-p3275-lve',
  'P3275-V': 'https://www.axis.com/products/axis-p3275-v',
  'P3277-LV': 'https://www.axis.com/products/axis-p3277-lv',
  'P3277-LVE': 'https://www.axis.com/products/axis-p3277-lve',
  'P3278-LV': 'https://www.axis.com/products/axis-p3278-lv',
  'P3278-LVE': 'https://www.axis.com/products/axis-p3278-lve',

  // P32xx - Audio-enabled variants (ARTPEC-9)
  'P3285-LV': 'https://www.axis.com/products/axis-p3285-lv',
  'P3285-LVE': 'https://www.axis.com/products/axis-p3285-lve',
  'P3287-LV': 'https://www.axis.com/products/axis-p3287-lv',
  'P3287-LVE': 'https://www.axis.com/products/axis-p3287-lve',
  'P3288-LV': 'https://www.axis.com/products/axis-p3288-lv',
  'P3288-LVE': 'https://www.axis.com/products/axis-p3288-lve',

  // P32xx - Legacy (still available)
  'P3245-LV': 'https://www.axis.com/products/axis-p3245-lv',
  'P3245-LVE': 'https://www.axis.com/products/axis-p3245-lve',
  'P3245-V': 'https://www.axis.com/products/axis-p3245-v',
  'P3245-VE': 'https://www.axis.com/products/axis-p3245-ve',
  'P3255-LVE': 'https://www.axis.com/products/axis-p3255-lve',

  // ===========================================================================
  // P-SERIES BULLETS (P14xx) - ARTPEC-8/9
  // ===========================================================================

  // P14xx - Current models (ARTPEC-8)
  'P1445-LE': 'https://www.axis.com/products/axis-p1445-le',
  'P1447-LE': 'https://www.axis.com/products/axis-p1447-le',
  'P1448-LE': 'https://www.axis.com/products/axis-p1448-le',
  'P1455-LE': 'https://www.axis.com/products/axis-p1455-le', // Discontinued
  'P1465-LE': 'https://www.axis.com/products/axis-p1465-le',
  'P1465-LE-3': 'https://www.axis.com/products/axis-p1465-le-3',
  'P1467-LE': 'https://www.axis.com/products/axis-p1467-le',
  'P1468-LE': 'https://www.axis.com/products/axis-p1468-le',
  'P1468-XLE': 'https://www.axis.com/products/axis-p1468-xle', // Explosion protected

  // P14xx - NEW ARTPEC-9 bullets (2025-2026)
  'P1475-LE': 'https://www.axis.com/products/axis-p1475-le',
  'P1485-LE': 'https://www.axis.com/products/axis-p1485-le',
  'P1487-LE': 'https://www.axis.com/products/axis-p1487-le',
  'P1488-LE': 'https://www.axis.com/products/axis-p1488-le',

  // ===========================================================================
  // P-SERIES BOX CAMERAS (P13xx/P15xx)
  // ===========================================================================

  'P1385': 'https://www.axis.com/products/axis-p1385',
  'P1385-E': 'https://www.axis.com/products/axis-p1385-e',
  'P1385-LE': 'https://www.axis.com/products/axis-p1385-le',
  'P1387': 'https://www.axis.com/products/axis-p1387',
  'P1387-E': 'https://www.axis.com/products/axis-p1387-e',
  'P1387-LE': 'https://www.axis.com/products/axis-p1387-le',
  'P1388': 'https://www.axis.com/products/axis-p1388',
  'P1388-E': 'https://www.axis.com/products/axis-p1388-e',
  'P1388-LE': 'https://www.axis.com/products/axis-p1388-le',
  'P1515': 'https://www.axis.com/products/axis-p1515',
  'P1518-LE': 'https://www.axis.com/products/axis-p1518-le',

  // ===========================================================================
  // P-SERIES PANORAMIC (P37xx/P47xx)
  // ===========================================================================

  'P3715-PLVE': 'https://www.axis.com/products/axis-p3715-plve',
  'P3717-PLE': 'https://www.axis.com/products/axis-p3717-ple',
  'P3719-PLE': 'https://www.axis.com/products/axis-p3719-ple',
  'P3735-PLE': 'https://www.axis.com/products/axis-p3735-ple',
  'P3737-PLE': 'https://www.axis.com/products/axis-p3737-ple',
  'P3738-PLE': 'https://www.axis.com/products/axis-p3738-ple',
  'P3807-PVE': 'https://www.axis.com/products/axis-p3807-pve',
  'P3827-PVE': 'https://www.axis.com/products/axis-p3827-pve',
  'P4705-PLVE': 'https://www.axis.com/products/axis-p4705-plve',
  'P4707-PLVE': 'https://www.axis.com/products/axis-p4707-plve',

  // ===========================================================================
  // P-SERIES ONBOARD (P39xx)
  // ===========================================================================

  'P3925-R': 'https://www.axis.com/products/axis-p3925-r',
  'P3925-LRE': 'https://www.axis.com/products/axis-p3925-lre',
  'P3935-LR': 'https://www.axis.com/products/axis-p3935-lr',
  'P3935-LRE': 'https://www.axis.com/products/axis-p3935-lre',

  // ===========================================================================
  // P-SERIES PTZ (P55xx/P56xx)
  // ===========================================================================

  'P5534': 'https://www.axis.com/products/axis-p5534',
  'P5534-E': 'https://www.axis.com/products/axis-p5534-e',
  'P5635-E': 'https://www.axis.com/products/axis-p5635-e',
  'P5654-E': 'https://www.axis.com/products/axis-p5654-e',
  'P5654-E-MK-II': 'https://www.axis.com/products/axis-p5654-e-mk-ii',
  'P5655-E': 'https://www.axis.com/products/axis-p5655-e',

  // ===========================================================================
  // P-SERIES SPECIALTY
  // ===========================================================================

  'P9117-PV': 'https://www.axis.com/products/axis-p9117-pv',
  'P1244': 'https://www.axis.com/products/axis-p1244',
  'P1245-E': 'https://www.axis.com/products/axis-p1245-e',
  'P1245-MK-II': 'https://www.axis.com/products/axis-p1245-mk-ii',

  // ===========================================================================
  // Q-SERIES DOMES (Q35xx/Q36xx) - Premium
  // ===========================================================================

  // Q35xx - ARTPEC-8 (phasing out)
  'Q3515-LV': 'https://www.axis.com/products/axis-q3515-lv',
  'Q3515-LVE': 'https://www.axis.com/products/axis-q3515-lve',
  'Q3517-LV': 'https://www.axis.com/products/axis-q3517-lv',
  'Q3517-LVE': 'https://www.axis.com/products/axis-q3517-lve',
  'Q3517-SLVE': 'https://www.axis.com/products/axis-q3517-slve',
  'Q3518-LVE': 'https://www.axis.com/products/axis-q3518-lve',
  'Q3536-LVE': 'https://www.axis.com/products/axis-q3536-lve', // Migrating to Q3556
  'Q3538-LVE': 'https://www.axis.com/products/axis-q3538-lve', // Migrating to Q3558
  'Q3538-SLVE': 'https://www.axis.com/products/axis-q3538-slve',

  // Q35xx - NEW ARTPEC-9 models (2025-2026)
  'Q3546-LVE': 'https://www.axis.com/products/axis-q3546-lve',
  'Q3548-LVE': 'https://www.axis.com/products/axis-q3548-lve',
  'Q3556-LVE': 'https://www.axis.com/products/axis-q3556-lve',
  'Q3558-LVE': 'https://www.axis.com/products/axis-q3558-lve',

  // Q36xx - Advanced with remote adjustment
  'Q3626-VE': 'https://www.axis.com/products/axis-q3626-ve',
  'Q3628-VE': 'https://www.axis.com/products/axis-q3628-ve',

  // ===========================================================================
  // Q-SERIES BULLETS (Q17xx/Q18xx)
  // ===========================================================================

  'Q1700-LE': 'https://www.axis.com/products/axis-q1700-le',
  'Q1715': 'https://www.axis.com/products/axis-q1715',
  'Q1728': 'https://www.axis.com/products/axis-q1728',
  'Q1728-LE': 'https://www.axis.com/products/axis-q1728-le',
  'Q1765-LE': 'https://www.axis.com/products/axis-q1765-le',
  'Q1785-LE': 'https://www.axis.com/products/axis-q1785-le',
  'Q1786-LE': 'https://www.axis.com/products/axis-q1786-le',
  'Q1795-LE': 'https://www.axis.com/products/axis-q1795-le',
  'Q1796-LE': 'https://www.axis.com/products/axis-q1796-le',
  'Q1798-LE': 'https://www.axis.com/products/axis-q1798-le',
  'Q1808-LE': 'https://www.axis.com/products/axis-q1808-le',

  // ===========================================================================
  // Q-SERIES BOX (Q16xx)
  // ===========================================================================

  'Q1615': 'https://www.axis.com/products/axis-q1615',
  'Q1645': 'https://www.axis.com/products/axis-q1645',
  'Q1647': 'https://www.axis.com/products/axis-q1647',
  'Q1656': 'https://www.axis.com/products/axis-q1656',
  'Q1656-LE': 'https://www.axis.com/products/axis-q1656-le',
  'Q1656-DLE': 'https://www.axis.com/products/axis-q1656-dle',
  'Q1686-DLE': 'https://www.axis.com/products/axis-q1686-dle',

  // ===========================================================================
  // Q-SERIES PTZ (Q60xx/Q61xx/Q62xx/Q63xx)
  // ===========================================================================

  // Q60xx - Robust mission-critical
  'Q6010-E': 'https://www.axis.com/products/axis-q6010-e',
  'Q6074': 'https://www.axis.com/products/axis-q6074',
  'Q6074-E': 'https://www.axis.com/products/axis-q6074-e',
  'Q6075': 'https://www.axis.com/products/axis-q6075',
  'Q6075-E': 'https://www.axis.com/products/axis-q6075-e',
  'Q6075-S': 'https://www.axis.com/products/axis-q6075-s',
  'Q6075-SE': 'https://www.axis.com/products/axis-q6075-se',
  'Q6078-E': 'https://www.axis.com/products/axis-q6078-e',
  'Q6100-E': 'https://www.axis.com/products/axis-q6100-e',
  'Q6125-LE': 'https://www.axis.com/products/axis-q6125-le',
  'Q6135-LE': 'https://www.axis.com/products/axis-q6135-le',
  'Q6155-E': 'https://www.axis.com/products/axis-q6155-e',
  'Q6215-LE': 'https://www.axis.com/products/axis-q6215-le',
  'Q6225-LE': 'https://www.axis.com/products/axis-q6225-le',
  'Q6300-E': 'https://www.axis.com/products/axis-q6300-e',

  // Q63xx - NEW High-end ARTPEC-9 PTZ
  'Q6315-LE': 'https://www.axis.com/products/axis-q6315-le',
  'Q6318-LE': 'https://www.axis.com/products/axis-q6318-le',
  'Q6355': 'https://www.axis.com/products/axis-q6355',
  'Q6358': 'https://www.axis.com/products/axis-q6358',

  // ===========================================================================
  // Q-SERIES SPECIALTY
  // ===========================================================================

  'Q9216-SLV': 'https://www.axis.com/products/axis-q9216-slv',
  'Q9227-SLV': 'https://www.axis.com/products/axis-q9227-slv', // NEW
  'Q9307-LV': 'https://www.axis.com/products/axis-q9307-lv',
  'Q8752-E-MK-II': 'https://www.axis.com/products/axis-q8752-e-mk-ii',

  // ===========================================================================
  // Q-SERIES THERMAL
  // ===========================================================================

  'Q1951-E': 'https://www.axis.com/products/axis-q1951-e',
  'Q1952-E': 'https://www.axis.com/products/axis-q1952-e',
  'Q1961-TE': 'https://www.axis.com/products/axis-q1961-te',
  'Q1961-XTE': 'https://www.axis.com/products/axis-q1961-xte',
  'Q2101-TE': 'https://www.axis.com/products/axis-q2101-te',
  'Q2112-E': 'https://www.axis.com/products/axis-q2112-e',
  'Q2901-E': 'https://www.axis.com/products/axis-q2901-e',

  // ===========================================================================
  // Q-SERIES LPR/TRAFFIC
  // ===========================================================================

  'Q1800-LE': 'https://www.axis.com/products/axis-q1800-le',
  'Q1800-LE-3': 'https://www.axis.com/products/axis-q1800-le-3',

  // ===========================================================================
  // M-SERIES COMPACT DOMES (M30xx)
  // ===========================================================================

  'M3085-V': 'https://www.axis.com/products/axis-m3085-v',
  'M3085-VE': 'https://www.axis.com/products/axis-m3085-ve',
  'M3086-V': 'https://www.axis.com/products/axis-m3086-v',
  'M3087-V': 'https://www.axis.com/products/axis-m3087-v',
  'M3087-PV': 'https://www.axis.com/products/axis-m3087-pv',
  'M3088-V': 'https://www.axis.com/products/axis-m3088-v',
  'M3057-PLVE': 'https://www.axis.com/products/axis-m3057-plve',
  'M3067-P': 'https://www.axis.com/products/axis-m3067-p',
  'M3068-P': 'https://www.axis.com/products/axis-m3068-p',
  'M3075-V': 'https://www.axis.com/products/axis-m3075-v',
  'M3077-PLVE': 'https://www.axis.com/products/axis-m3077-plve',

  // ===========================================================================
  // M-SERIES FLAT-FACED DOMES (M31xx)
  // ===========================================================================

  'M3115-LVE': 'https://www.axis.com/products/axis-m3115-lve',
  'M3116-LVE': 'https://www.axis.com/products/axis-m3116-lve',
  'M3126-LVE': 'https://www.axis.com/products/axis-m3126-lve',

  // ===========================================================================
  // M-SERIES FIXED DOMES (M32xx)
  // ===========================================================================

  'M3215-LVE': 'https://www.axis.com/products/axis-m3215-lve',
  'M3216-LVE': 'https://www.axis.com/products/axis-m3216-lve',

  // ===========================================================================
  // M-SERIES TURRETS (M42xx)
  // ===========================================================================

  'M4215-LV': 'https://www.axis.com/products/axis-m4215-lv',
  'M4215-V': 'https://www.axis.com/products/axis-m4215-v',
  'M4216-LV': 'https://www.axis.com/products/axis-m4216-lv',
  'M4216-V': 'https://www.axis.com/products/axis-m4216-v',
  'M4218-LV': 'https://www.axis.com/products/axis-m4218-lv',
  'M4218-V': 'https://www.axis.com/products/axis-m4218-v',
  'M4225-LVE': 'https://www.axis.com/products/axis-m4225-lve',
  'M4226-LVE': 'https://www.axis.com/products/axis-m4226-lve',
  'M4228-LVE': 'https://www.axis.com/products/axis-m4228-lve',

  // ===========================================================================
  // M-SERIES PANORAMIC (M43xx)
  // ===========================================================================

  'M4308-PLE': 'https://www.axis.com/products/axis-m4308-ple',
  'M4317-PLVE': 'https://www.axis.com/products/axis-m4317-plve',
  'M4317-PLR': 'https://www.axis.com/products/axis-m4317-plr',
  'M4318-PLVE': 'https://www.axis.com/products/axis-m4318-plve',
  'M4318-PLR': 'https://www.axis.com/products/axis-m4318-plr',

  // ===========================================================================
  // M-SERIES BULLETS (M20xx)
  // ===========================================================================

  'M2035-LE': 'https://www.axis.com/products/axis-m2035-le',
  'M2036-LE': 'https://www.axis.com/products/axis-m2036-le',

  // ===========================================================================
  // M-SERIES PTZ (M50xx/M55xx)
  // ===========================================================================

  'M5000': 'https://www.axis.com/products/axis-m5000',
  'M5000-G': 'https://www.axis.com/products/axis-m5000-g',
  'M5013': 'https://www.axis.com/products/axis-m5013',
  'M5014': 'https://www.axis.com/products/axis-m5014',
  'M5074': 'https://www.axis.com/products/axis-m5074',
  'M5525-E': 'https://www.axis.com/products/axis-m5525-e',
  'M5526-E': 'https://www.axis.com/products/axis-m5526-e',

  // ===========================================================================
  // M-SERIES BOX (M10xx/M11xx)
  // ===========================================================================

  'M1075-L': 'https://www.axis.com/products/axis-m1075-l',
  'M1055-L': 'https://www.axis.com/products/axis-m1055-l',
  'M1135': 'https://www.axis.com/products/axis-m1135',
  'M1135-E': 'https://www.axis.com/products/axis-m1135-e',
  'M1137': 'https://www.axis.com/products/axis-m1137',
  'M1137-E': 'https://www.axis.com/products/axis-m1137-e',

  // ===========================================================================
  // M-SERIES ONBOARD
  // ===========================================================================

  'M3057-PLR-MK-II': 'https://www.axis.com/products/axis-m3057-plr-mk-ii',
  'M3905-R': 'https://www.axis.com/products/axis-m3905-r',

  // ===========================================================================
  // F-SERIES (MODULAR)
  // ===========================================================================

  // Main Units
  'F9104-B': 'https://www.axis.com/products/axis-f9104-b',
  'F9111': 'https://www.axis.com/products/axis-f9111',
  'F9111-B': 'https://www.axis.com/products/axis-f9111-b',
  'F9111-R-MK-II': 'https://www.axis.com/products/axis-f9111-r-mk-ii',
  'F9114': 'https://www.axis.com/products/axis-f9114',
  'F9114-B': 'https://www.axis.com/products/axis-f9114-b',
  'F9124': 'https://www.axis.com/products/axis-f9124',
  'F34': 'https://www.axis.com/products/axis-f34',
  'F41': 'https://www.axis.com/products/axis-f41',
  'F44': 'https://www.axis.com/products/axis-f44',

  // Sensor Units
  'F1015': 'https://www.axis.com/products/axis-f1015',
  'F1025': 'https://www.axis.com/products/axis-f1025',
  'F1035-E': 'https://www.axis.com/products/axis-f1035-e',
  'F2105-RE': 'https://www.axis.com/products/axis-f2105-re',
  'F2115-R': 'https://www.axis.com/products/axis-f2115-r',
  'F2135-RE': 'https://www.axis.com/products/axis-f2135-re',
  'F4005-E': 'https://www.axis.com/products/axis-f4005-e',
  'F4105-LRE': 'https://www.axis.com/products/axis-f4105-lre',
  'F4108': 'https://www.axis.com/products/axis-f4108',
  'FA1105': 'https://www.axis.com/products/axis-fa1105',
  'FA1125': 'https://www.axis.com/products/axis-fa1125',
  'FA3105-L': 'https://www.axis.com/products/axis-fa3105-l',
  'FA4115': 'https://www.axis.com/products/axis-fa4115',

  // ===========================================================================
  // V-SERIES (CONFERENCING/STREAMING)
  // ===========================================================================

  'V5914': 'https://www.axis.com/products/axis-v5914',
  'V5915': 'https://www.axis.com/products/axis-v5915',
  'V5938': 'https://www.axis.com/products/axis-v5938',

  // ===========================================================================
  // W-SERIES (BODY WORN)
  // ===========================================================================

  'W110': 'https://www.axis.com/products/axis-w110',
  'W120': 'https://www.axis.com/products/axis-w120',
  'W800': 'https://www.axis.com/products/axis-w800',

  // ===========================================================================
  // EXPLOSION PROTECTED (XP/XQ SERIES)
  // ===========================================================================

  'XP40-Q1765': 'https://www.axis.com/products/axis-xp40-q1765',
  'XP40-Q1785': 'https://www.axis.com/products/axis-xp40-q1785',
  'XP40-Q1942': 'https://www.axis.com/products/axis-xp40-q1942',
  'XP40-Q1965': 'https://www.axis.com/products/axis-xp40-q1965',
  'XQ1785': 'https://www.axis.com/products/axis-xq1785',

  // ===========================================================================
  // A-SERIES (DOOR STATIONS) - Legacy entries
  // ===========================================================================

  'A8207-VE': 'https://www.axis.com/products/axis-a8207-ve',
  'A8207-VE-MK-II': 'https://www.axis.com/products/axis-a8207-ve-mk-ii',

  // ===========================================================================
  // RECORDING SOLUTIONS (S-SERIES)
  // ===========================================================================

  'S1216': 'https://www.axis.com/products/axis-s1216-tower-mk-ii',
  'S1224': 'https://www.axis.com/products/axis-s1224-rack',
  'S1228': 'https://www.axis.com/products/axis-s1228-rack',
  'S1232': 'https://www.axis.com/products/axis-s1232-rack',
  'S1264': 'https://www.axis.com/products/axis-s1264-rack',
  'S1296': 'https://www.axis.com/products/axis-s1296-rack',
  'S2108': 'https://www.axis.com/products/axis-s2108',
  'S2208': 'https://www.axis.com/products/axis-s2208-mk-ii',
  'S2212': 'https://www.axis.com/products/axis-s2212-mk-ii',
  'S2216': 'https://www.axis.com/products/axis-s2216-mk-ii',
  'S2224': 'https://www.axis.com/products/axis-s2224-mk-ii',
  'S3008': 'https://www.axis.com/products/axis-s3008-mk-ii',
  'S3016': 'https://www.axis.com/products/axis-s3016',
  'S4000': 'https://www.axis.com/products/axis-s4000',
  'S9301': 'https://www.axis.com/products/axis-s9301-mk-ii',
  'S9302': 'https://www.axis.com/products/axis-s9302-mk-ii',

  // ===========================================================================
  // NETWORK SWITCHES (D80xx, T85xx, T86xx)
  // ===========================================================================

  'D8004': 'https://www.axis.com/products/axis-d8004-unmanaged-poe-switch',
  'D8208': 'https://www.axis.com/products/axis-d8208-r-industrial-poe-switch',
  'D8208-R': 'https://www.axis.com/products/axis-d8208-r-industrial-poe-switch',
  'D8248': 'https://www.axis.com/products/axis-d8248-managed-poe-switch',
  'D8308': 'https://www.axis.com/products/axis-d8308-fiber-aggregation-switch',
  'T8504-E': 'https://www.axis.com/products/axis-t8504-e-outdoor-poe-switch',
  'T8504-R': 'https://www.axis.com/products/axis-t8504-r-industrial-poe-switch',
  'T8508': 'https://www.axis.com/products/axis-t8508-poe-network-switch',
  'T8516': 'https://www.axis.com/products/axis-t8516-poe-network-switch',
  'T8524': 'https://www.axis.com/products/axis-t8524-poe-network-switch',
  'T8604': 'https://www.axis.com/products/axis-t8604-media-converter-switch',
  'T8606': 'https://www.axis.com/products/axis-t8606-media-converter-switch-24-v-dc',
  'T8611': 'https://www.axis.com/products/axis-t8611-sfp-module-lclx',
  'T8612': 'https://www.axis.com/products/axis-t8612-sfp-module-lcsx',
  'T8613': 'https://www.axis.com/products/axis-t8613-sfp-module-1000base-t',
  'T8640': 'https://www.axis.com/products/axis-t8640-poe-over-coax-adapter-kit',
  'T8641': 'https://www.axis.com/products/axis-t8641-poe-over-coax-base-unit',
  'T8642': 'https://www.axis.com/products/axis-t8642-poe-over-coax-device-unit',
  'T8643': 'https://www.axis.com/products/axis-t8643-poe-over-coax-compact-kit',
  'T8645': 'https://www.axis.com/products/axis-t8645-poe-over-coax-compact-kit',

  // ===========================================================================
  // VIDEO ENCODERS
  // ===========================================================================

  'M7104': 'https://www.axis.com/products/axis-m7104',
  'M7116': 'https://www.axis.com/products/axis-m7116',
  'P7304': 'https://www.axis.com/products/axis-p7304',
  'P7316': 'https://www.axis.com/products/axis-p7316',

  // ===========================================================================
  // NETWORK AUDIO (C-SERIES)
  // ===========================================================================

  'C1004-E': 'https://www.axis.com/products/axis-c1004-e',
  'C1110-E': 'https://www.axis.com/products/axis-c1110-e',
  'C1111-E': 'https://www.axis.com/products/axis-c1111-e',
  'C1210-E': 'https://www.axis.com/products/axis-c1210-e',
  'C1211-E': 'https://www.axis.com/products/axis-c1211-e',
  'C1310-E': 'https://www.axis.com/products/axis-c1310-e-mk-ii',
  'C1410': 'https://www.axis.com/products/axis-c1410-mk-ii',
  'C1510': 'https://www.axis.com/products/axis-c1510',
  'C1511': 'https://www.axis.com/products/axis-c1511',
  'C1610-VE': 'https://www.axis.com/products/axis-c1610-ve',
  'C1710': 'https://www.axis.com/products/axis-c1710',
  'C1720': 'https://www.axis.com/products/axis-c1720',
  'C6110': 'https://www.axis.com/products/axis-c6110',
  'C7050': 'https://www.axis.com/products/axis-c7050-mk-iii',
  'C8110': 'https://www.axis.com/products/axis-c8110',
  'C8210': 'https://www.axis.com/products/axis-c8210',
  'C8310': 'https://www.axis.com/products/axis-c8310',

  // ===========================================================================
  // NETWORK INTERCOMS & DOOR STATIONS
  // ===========================================================================

  'A1001': 'https://www.axis.com/products/axis-a1001',
  'A1210': 'https://www.axis.com/products/axis-a1210',
  'A1210-B': 'https://www.axis.com/products/axis-a1210-b',
  'A1214': 'https://www.axis.com/products/axis-a1214',
  'A1601': 'https://www.axis.com/products/axis-a1601',
  'A1610': 'https://www.axis.com/products/axis-a1610',
  'A1610-B': 'https://www.axis.com/products/axis-a1610-b',
  'A1710-B': 'https://www.axis.com/products/axis-a1710-b',
  'A1711': 'https://www.axis.com/products/axis-a1711',
  'A1810-B': 'https://www.axis.com/products/axis-a1810-b',
  'A1811': 'https://www.axis.com/products/axis-a1811',
  'I5304': 'https://www.axis.com/products/axis-i5304',
  'I7010-VE': 'https://www.axis.com/products/axis-i7010-ve',
  'I7020': 'https://www.axis.com/products/axis-i7020',
  'I8016-LVE': 'https://www.axis.com/products/axis-i8016-lve',
  'I8116-E': 'https://www.axis.com/products/axis-i8116-e',
  'I8307-VE': 'https://www.axis.com/products/axis-i8307-ve',

  // ===========================================================================
  // MOUNTS & BRACKETS (T91)
  // ===========================================================================

  'T91A23': 'https://www.axis.com/products/axis-t91a23-tile-grid-ceiling-mount',
  'T91A33': 'https://www.axis.com/products/axis-t91a33-lighting-track-mount',
  'T91A64': 'https://www.axis.com/products/axis-t91a64-corner-bracket',
  'T91B47': 'https://www.axis.com/products/axis-t91b47-pole-mount',
  'T91B50': 'https://www.axis.com/products/axis-t91b50-telescopic-ceiling-mount',
  'T91B51': 'https://www.axis.com/products/axis-t91b51-ceiling-mount',
  'T91B53': 'https://www.axis.com/products/axis-t91b53-telescopic-ceiling-mount',
  'T91B57': 'https://www.axis.com/products/axis-t91b57-pole-mount',
  'T91B63': 'https://www.axis.com/products/axis-t91b63-ceiling-mount',
  'T91B67': 'https://www.axis.com/products/axis-t91b67-pole-mount',
  'T91D61': 'https://www.axis.com/products/axis-t91d61-wall-mount-15-nps',
  'T91D62': 'https://www.axis.com/products/axis-t91d62-telescopic-parapet-mount',
  'T91F67': 'https://www.axis.com/products/axis-t91f67-pole-mount',
  'T91G61': 'https://www.axis.com/products/axis-t91g61-wall-mount',
  'T91H61': 'https://www.axis.com/products/axis-t91h61-wall-mount',
  'T91R61': 'https://www.axis.com/products/axis-t91r61-wall-mount',

  // ===========================================================================
  // RADAR & DETECTION (D-SERIES)
  // ===========================================================================

  'D1110': 'https://www.axis.com/products/axis-d1110-video-decoder-4k',
  'D2110-VE': 'https://www.axis.com/products/axis-d2110-ve-security-radar',
  'D2122-VE': 'https://www.axis.com/products/axis-d2122-ve-radar',
  'D2123-VE': 'https://www.axis.com/products/axis-d2123-ve-radar',
  'D2210-VE': 'https://www.axis.com/products/axis-d2210-ve-radar',
  'D3110': 'https://www.axis.com/products/axis-d3110-mk-ii-connectivity-hub',
  'D4100-VE': 'https://www.axis.com/products/axis-d4100-ve-mk-ii-network-strobe-siren',
  'D4200-VE': 'https://www.axis.com/products/axis-d4200-ve-network-strobe-speaker',
  'D6210-AIR': 'https://www.axis.com/products/axis-d6210-air-quality-sensor',
  'D6310-AIR': 'https://www.axis.com/products/axis-d6310-air-quality-sensor',
};

/**
 * Count of verified URLs (for debugging/stats)
 */
export const VERIFIED_URL_COUNT = Object.keys(VERIFIED_URLS).length;
